var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCloud224X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_cloud2_24x24",
    transform: "translate(-3 -2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(3 2.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25237",
    "data-name": "Group 25237",
    transform: "translate(2.793)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25236",
    "data-name": "Group 25236"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46249",
    "data-name": "Path 46249",
    d: "M101.5,4.841,96.8.139a.474.474,0,0,0-.671,0l-4.7,4.7a.474.474,0,0,0,0,.671l1.342,1.341a.474.474,0,0,0,.671,0l1.6-1.6v6.524a.463.463,0,0,0,.474.461h1.9a.463.463,0,0,0,.474-.461V5.251l1.6,1.6a.474.474,0,0,0,.671,0L101.5,5.513a.474.474,0,0,0,0-.672Z",
    transform: "translate(-91.288)",
    fill: "#999"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25239",
    "data-name": "Group 25239",
    transform: "translate(0 10.309)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25238",
    "data-name": "Group 25238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46250",
    "data-name": "Path 46250",
    d: "M15.532,332H13.656a.471.471,0,0,0-.468.474v2.371H2.812v-2.371A.471.471,0,0,0,2.344,332H.468a.471.471,0,0,0-.468.474v3.794a1.416,1.416,0,0,0,1.406,1.423H14.594A1.416,1.416,0,0,0,16,336.268v-3.794A.471.471,0,0,0,15.532,332Z",
    transform: "translate(0 -332)",
    fill: "#999"
  })))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCloud224X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_cloud2_24x24.9919ee6a7ed5368c4787565f62d7833c.svg";